/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeoPosition } from './GeoPosition';
export type ToolInventoryHistoryEntry = {
    id: string;
    tool_id: string;
    tool_inventory_id: string;
    type: ToolInventoryHistoryEntry.type;
    year: number;
    created_at: string;
    updated_by_id: string;
    moved_counterpart_tool_id: string | null;
    position: GeoPosition | null;
    photo_ids: Array<string>;
};
export namespace ToolInventoryHistoryEntry {
    export enum type {
        CREATE = 'create',
        UPDATE = 'update',
        DELETE = 'delete',
        MOVED_TO = 'moved_to',
        MOVED_FROM = 'moved_from',
    }
}

